export default "__VITE_ASSET__D$F97sGi__"